import { render, staticRenderFns } from "./xsftjllist.vue?vue&type=template&id=856752fe&scoped=true&"
import script from "./xsftjllist.vue?vue&type=script&lang=js&"
export * from "./xsftjllist.vue?vue&type=script&lang=js&"
import style0 from "./xsftjllist.vue?vue&type=style&index=0&id=856752fe&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856752fe",
  null
  
)

export default component.exports